import React, { useEffect, useRef } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { STATUSARRAY } from "../../_contstants/common";
import { clearUnitDetails, closeUnitDrawerOpen } from "./unitSlice";
import {
  createUnit,
  findAllActiveUnit,
  getAllUnit,
  getUnitById,
  updateUnit,
} from "./services/unit.services";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";

const CreateUnit: React.FC = () => {
  const formLoading = useAppSelector((state) => state.unit.formLoading);
  const UnitDetail = useAppSelector((state) => state.unit.UnitDetail);
  const unit_guid = useAppSelector((state) => state.muidrawer.data);
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);
  const unitDrawerOpen = useAppSelector((state) => state.unit.unitDrawerOpen);

  useEffect(() => {
    return () => {
      dispatch(clearUnitDetails());
      if (unitDrawerOpen) {
        dispatch(closeUnitDrawerOpen());
      } else {
        dispatch(closed());
      }
    };
  }, []);

  useEffect(() => {
    if (unit_guid) {
      dispatch(getUnitById(unit_guid));
    }
  }, [unit_guid]);

  const handleSubmit = async (values: any) => {
    try {
      if (!unit_guid) {
        const payload = {
          unit_name: values.unit_name,
          short_code: values.short_code,
          conversion_rate: values.conversion_rate,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createUnit(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (unitDrawerOpen) {
            dispatch(closeUnitDrawerOpen());
          } else {
            dispatch(closed());
          }
          dispatch(clearUnitDetails());
          isIndirect || unitDrawerOpen
            ? dispatch(findAllActiveUnit())
            : dispatch(getAllUnit());
        }
      } else {
        const payload = {
          unit_guid: unit_guid,
          unit_name: values.unit_name,
          short_code: values.short_code,
          conversion_rate: values.conversion_rate,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateUnit(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (unitDrawerOpen) {
            dispatch(closeUnitDrawerOpen());
          } else {
            dispatch(closed());
          }
          dispatch(clearUnitDetails());
          isIndirect || unitDrawerOpen
            ? dispatch(findAllActiveUnit())
            : dispatch(getAllUnit());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    if (unitDrawerOpen) {
      dispatch(closeUnitDrawerOpen());
    } else {
      dispatch(closed());
    }
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={UnitDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="unit_name"
                label="Unit Name"
                placeholder="i.e. GRAM"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="short_code"
                label="Short Code"
                placeholder="i.e. GM"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="conversion_rate"
                label="Conversion Rate"
                component={FormNumericTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"isactive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator}
                astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={unit_guid ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateUnit;
